import styles from './ActiveMicIcon.module.scss';

const ActiveMicIcon = ({ active, preparing, audioLevel }: { active: boolean; preparing: boolean; audioLevel: number; }) => {
    return <div className={styles.mic} data-active={active} data-preparing={preparing}>
        <div className={styles.level} style={{ height: audioLevel * 100 + '%' }}></div>

    </div>;
};

export default ActiveMicIcon;